export default "__VITE_ASSET__DlNRJMUb__"